import { Box } from 'shared';
import styled from 'theme';

export const AdminToolBoxWrapper = styled(Box)`
  display: flex;
  flex-flow: column;
  font-family: ${props => props.theme.variables.typography.secondaryFont};
  background-color: white;
  border-radius: ${props => props.theme.variables.borders.radius};
  box-shadow: ${props => props.theme.variables.customColors.boxShadow};
  overflow: hidden;
  height: 100%;
  min-height: 11rem;
  padding: 1.5rem 2rem;
  transition: box-shadow 0.3s ease-in-out;

  &:hover {
    box-shadow: ${props => props.theme.variables.shadows.shadow};
  }
`;

export const AdminToolName = styled.div`
  color: ${props => props.theme.variables.customColors.leadingColor.base};
  font-size: 1.5rem;
  line-height: 2rem;
  margin-bottom: 0.5rem;
`;

export const AdminToolDescription = styled.div`
  display: flex;
  font-family: ${props => props.theme.variables.typography.primaryFont};
  font-size: ${props => props.theme.variables.fonts.size.smaller1};
  color: ${props => props.theme.variables.customColors.lightGreyText};
  font-weight: ${props => props.theme.variables.fonts.weight.light};
  line-height: 1.7;
  overflow: hidden;
  margin-top: 1rem;
  align-items: center;
  max-height: 3.5rem;

  &::after {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 50%;
    height: 1rem;
    background-image: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.55) 45%, #ffffff);
  }
`;
